module.exports = __webpack_public_path__ + "resources/img/sp_intro_m.52713ec0e788bd465f5b7d067aa413cf.png";